// extracted by mini-css-extract-plugin
export default {"pickerWrap":"pickerWrap--SGTcs","shortcuts":"shortcuts--UNXo1","darkText":"darkText--UV7Vk"};